import { Button, Tooltip } from '@fluentui/react-components'
import styles from './TooltipIconButton.module.css'
import {
  ChevronDown24Regular,
  ChevronRight24Regular,
  CalendarLtr24Regular,
  ColumnTripleRegular,
  TableSimpleRegular,
} from '@fluentui/react-icons'

interface TooltipIconButtonProps {
  tooltipId: string
  tooltipContent: string
  buttonIcon?: string
  buttonLetter?: string
  clickFunction: () => boolean | void
  clickState?: boolean
  disabled?: boolean
}

// Helper function to map icon names to FluentUI v9 icons
const getIcon = (iconName?: string) => {
  if (!iconName) return null

  // Map icon names to their components
  const iconMap: Record<string, JSX.Element> = {
    ChevronDown: <ChevronDown24Regular />,
    ChevronRight: <ChevronRight24Regular />,
    EventDate: <CalendarLtr24Regular />,
    ColumnRightTwoThirds: <ColumnTripleRegular />,
    DuplicateRow: <TableSimpleRegular />,
  }

  return iconMap[iconName] || null
}

const TooltipIconButton = ({
  tooltipId,
  tooltipContent,
  buttonIcon,
  buttonLetter,
  clickFunction,
  clickState,
  disabled,
}: TooltipIconButtonProps) => {
  const icon = buttonIcon ? getIcon(buttonIcon) : null

  // We'll handle icon and letter buttons differently
  if (icon) {
    return (
      <Tooltip content={tooltipContent} relationship="label">
        <Button
          data-testid={tooltipId}
          className={styles.TooltipIconButton}
          disabled={disabled}
          onClick={clickFunction}
          appearance="subtle"
          data-selected={clickState}
          icon={icon}
          style={{ width: '32px', maxWidth: '32px' }}
        />
      </Tooltip>
    )
  }

  // For letter buttons, use a different approach to avoid spacing issues
  return (
    <Tooltip content={tooltipContent} relationship="label">
      <Button
        data-testid={tooltipId}
        className={`${styles.TooltipIconButton} ${styles.letterButton}`}
        disabled={disabled}
        onClick={clickFunction}
        appearance="subtle"
        data-selected={clickState}
        data-content={buttonLetter}
        style={{
          padding: 0,
          width: '32px',
          minWidth: '32px',
          maxWidth: '32px',
        }}
      />
    </Tooltip>
  )
}

export default TooltipIconButton
